import { SeminarEntryForm, SeminarEntryFormProvider } from "../../../features/seminar"
import type { GetStaticProps, NextPageWithLayout } from "../../../types/next"

const SeminarEntryFormPage: NextPageWithLayout = () => {
  return <SeminarEntryForm />
}

export default SeminarEntryFormPage

SeminarEntryFormPage.getLayout = (page) => {
  return <SeminarEntryFormProvider>{page}</SeminarEntryFormProvider>
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      title: "P板.comセミナー お申込みフォーム | プリント基板ネット通販P板.com",
      seo: {
        description: "プリント基板ネット通販P板.comが運営する各種P板.comセミナー。",
      },
    },
  }
}
